/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description: 视频垂搜首页
 * @Date: 2020-06-29 10:41:15
 */
import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    itemData: [],
  }),
  mutations: {
    [types.UPDATE_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_HOME_DATA](state, itemData) {
      state.itemData = itemData;
    },
  },
  actions: {
    /**
     * 获取检索结果
     */
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, { routeName: route.name }, $params);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/home`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));

      result = result && result.data;
      const { status, head = '', itemData } = result || {};
      if (status === 301) return result;
      if (status === 0 && itemData) {
        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_HOME_DATA, itemData);
        return result;
      }
      commit(types.UPDATE_HEAD, '');
      commit(types.UPDATE_HOME_DATA, {});

      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
